/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Satellite2 = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={66} cy={66} r={66} fill="currentColor" />
      <path
        fill="#CAD0D8"
        d="M69 101c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm-6-87c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM16 70c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm97-34c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={43.5} cy={14.5} r={1.5} fill="#CAD0D8" />
      <circle cx={69.5} cy={34.5} r={1.5} fill="#CAD0D8" />
      <circle cx={31.5} cy={56.5} r={1.5} fill="#CAD0D8" />
      <circle cx={29.5} cy={30.5} r={1.5} fill="#CAD0D8" />
      <circle cx={100.5} cy={104.5} r={1.5} fill="#CAD0D8" />
      <circle cx={83.5} cy={116.5} r={1.5} fill="#CAD0D8" />
      <circle cx={100.5} cy={59.5} r={1.5} fill="#CAD0D8" />
      <circle cx={104.5} cy={87.5} r={1.5} fill="#CAD0D8" />
      <circle cx={22.5} cy={95.5} r={1.5} fill="#CAD0D8" />
      <circle cx={53.5} cy={114.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(14 44)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(39 97)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(119 65)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(88 21)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <path
        fill="#F18686"
        d="M51.558 69.834a7.5 7.5 0 0 1 10.6 10.6l-10.6-10.6z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M51.558 69.834a7.5 7.5 0 0 1 10.6 10.6l-10.6-10.6zM81.4 59.084a6.003 6.003 0 0 0-.77-9.14 6.226 6.226 0 0 0-7.942.882L61.104 62.41a2.998 2.998 0 0 0 0 4.242l4.244 4.244a2.998 2.998 0 0 0 4.242 0L81.4 59.084zm3.184-11.668l-3.182 3.182M54.12 82.025A5.83 5.83 0 0 1 50 77.854"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M58.652 87.474c-5.286 2.514-11.61.266-14.124-5.02a10.605 10.605 0 0 1 .014-9.136m27.17-4.544l4.242 4.242"
      />
      <path
        fill="#74B0F4"
        d="M74.894 74.078l2.122-2.122a2.998 2.998 0 0 1 4.242 0l6.364 6.364a2.998 2.998 0 0 1 0 4.242L85.5 84.684a2.998 2.998 0 0 1-4.242 0l-6.364-6.364a2.998 2.998 0 0 1 0-4.242zM47.316 46.5l2.122-2.122a2.998 2.998 0 0 1 4.242 0l6.364 6.364a2.998 2.998 0 0 1 0 4.242l-2.12 2.122a2.998 2.998 0 0 1-4.242 0l-6.366-6.364a3.002 3.002 0 0 1 0-4.242z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M74.894 74.078l2.122-2.122a2.998 2.998 0 0 1 4.242 0l6.364 6.364a2.998 2.998 0 0 1 0 4.242L85.5 84.684a2.998 2.998 0 0 1-4.242 0l-6.364-6.364a2.998 2.998 0 0 1 0-4.242zm-11.668-13.79l-4.242-4.242M47.316 46.5l2.122-2.122a2.998 2.998 0 0 1 4.242 0l6.364 6.364a2.998 2.998 0 0 1 0 4.242l-2.12 2.122a2.998 2.998 0 0 1-4.242 0l-6.366-6.364a3.002 3.002 0 0 1 0-4.242z"
      />
    </g>
  </svg>
));
